import { useMemo, useEffect } from 'react';
import { EqualityFn } from 'react-redux';

import { useAppDispatch, useAppSelector } from '@STORE/index';

import { deleteUserModalSlice, DeleteUserModalState } from '@REDUCERS';
import { AdminUser } from '@SERVICES';

function createDeleteUserModalHook() {
    return function useDeleteUserModal(onSuccess?: () => void) {
        const state = useAppSelector((store) => store.deleteUserModal);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: (user: AdminUser) => dispatch(deleteUserModalSlice.actions.open(user)),
            close: () => dispatch(deleteUserModalSlice.actions.close()),
            confirm: () => dispatch(deleteUserModalSlice.actions.confirm()),
        }), [dispatch]);

        useEffect(() => {
            if (state.confirmed && onSuccess) {
                onSuccess();
            }
        }, [state.confirmed, onSuccess]);

        return {
            state,
            actions,
        };
    };
}

export default createDeleteUserModalHook(); 